import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './actions';

export interface DeeplinkHandlersState {
  processing: boolean;
  lastResponse: any | null;
  error: string | null;
  errorCode: number | null;
}

export const initialState: DeeplinkHandlersState = {
  processing: false,
  lastResponse: null,
  error: null,
  errorCode: null,
};

const deeplinkHandlersReducer = createReducer(
  initialState,
  on(actions.ProcessProvetSendInvoice, (state) => ({
    ...state,
    processing: true,
    error: null,
    errorCode: null,
  })),
  on(actions.ProcessProvetSendInvoiceSuccess, (state, { response }) => ({
    ...state,
    processing: false,
    lastResponse: response,
    error: null,
    errorCode: null,
  })),
  on(actions.ProcessProvetSendInvoiceFail, (state, { error, errorCode }) => ({
    ...state,
    processing: false,
    error,
    errorCode: errorCode ?? null,
  }))
);

export function reducer(state: DeeplinkHandlersState | undefined, action: Action): DeeplinkHandlersState {
  return deeplinkHandlersReducer(state, action);
}